export default __webpack_public_path__ + "static/media/promo_01.8a956692.jpg";